import { useEffect, useRef } from "react";

type OperationResult = { loading: boolean; called: boolean; error?: unknown };

/**
 * @deprecated Use Apollo's `useMutation` hook with the `onError` option instead.
 */
export default function useMutationOnError<
	Execute,
	Result extends OperationResult,
>(
	onError: (error: Result["error"]) => void,
	[execute, result]: readonly [Execute, Result],
): readonly [Execute, Result] {
	const { loading, error, called } = result;
	const callback = useRef(onError);
	const hasFailed = !loading && called && Boolean(error);

	useEffect(() => {
		if (hasFailed) {
			callback.current(error);
		}
	}, [hasFailed, error]);

	useEffect(() => {
		callback.current = onError;
	}, [onError]);

	return [execute, { ...result }] as const;
}
